import dayjs from '@/localPlugins/dayjs';

export default value => dayjs(value).format('MMM DD, YYYY hh:mm A');
